import cn from "classnames";
import * as React from "react";
import FormInput from "./form-input";

// Define the event types

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  /**
   * Wrap the checkbox with a label
   */
  label?: string;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  isInline?: boolean;
}

const FormCheckbox: React.FC<Props> = ({
  className,
  label,
  value,
  name,
  checked,
  disabled,
  readOnly,
  onChange,
  onFocus,
  onBlur,
  isInline,
}) => {
  const classes = cn(
    "custom-control custom-checkbox",
    { "custom-control-inline": isInline },
    className
  );
  const inputComponent = (
    <FormInput
      type="checkbox"
      name={name}
      value={value}
      checked={checked}
      className={classes}
      disabled={disabled}
      readOnly={readOnly}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  );

  return label ? (
    <label className={classes}>
      {inputComponent}
      <span className="custom-control-label">{label}</span>
    </label>
  ) : (
    inputComponent
  );
};

/** @component */
export default FormCheckbox;
